import SelectPreferrence from "./SelectPreferrence";

export default SelectPreferrence;
